<template>
  <footer class="footer">
    <section class="footer-section" :class="{ 'not-full': !isFull && !isMobile() }"
      v-if="$route.path !== '/pay-mobile' && $route.path !== '/'">
      <img :src="isMobile() ? bg_footer_mobile : bg_footer" class="footer-bg-img" :class="{ 'radius': !isFull }" />
      <div class="footer-container">
        <p class="title">立即开启您的数字色彩之旅</p>
        <p class="desc">从这里开始，体验更好用的工具、更高效的管理方式</p>
        <div class="footer-form">
          <el-button type="primary" class="view-btn" @click="showBookinng">
            <span class="btn-text">立即体验</span>
            <el-icon class="el-icon--right">
              <Right />
            </el-icon>
          </el-button>
        </div>
      </div>
    </section>
    <div class="footer_black">微谱数科 | 粤ICP备14014326号 粤公网安备44010502002922</div>

    <!-- 预约弹窗 -->
    <!-- <BookingDialog :visible="bookingDialogVisible" :type="currentDialogType" :phone="bookingForm.phone"
      @cancel="bookingDialogVisible = false" @confirm="handleBookingConfirm"></BookingDialog> -->

    <!-- 成功提示弹窗 -->
    <!-- <TipsDialog :visible="dialogVisible" :type="currentDialogType" @cancel="dialogVisible = false"
      @confirm="handleConfirm"></TipsDialog> -->
  </footer>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import BookingDialog from '@/components/BookingDialog.vue'
import TipsDialog from '@/components/TipsDialog.vue'
import { isMobile } from '@/utils/index';
import bg_footer from '@/assets/bg_footer.png'
import bg_footer_mobile from '@/assets/bg_footer_mobile.png'

defineProps({
  isFull: {
    type: Boolean,
    default: true
  },
  showBookinng: {
    type: Boolean,
    default: true
  }
})


// 弹窗相关
const dialogVisible = ref(false)
//booking弹窗
const bookingDialogVisible = ref(false)

// 当前对话框类型
const currentDialogType = ref('fee') // 默认为免费版

// 预约表单数据
const bookingForm = reactive({
  name: undefined,
  phone: undefined,
  company: undefined,
  appointmentTime: undefined,
  requirements: undefined
})

const handleBookingConfirm = () => {
  dialogVisible.value = true
  currentDialogType.value = 'booking'
  bookingForm.phone = ''
}

const emit = defineEmits(['showBookingDialog'])
const showBookinng = () => {
  // bookingDialogVisible.value = true
  // 通过emit抛出事件
  emit('on-show-booking-dialog')
}

const handleConfirm = () => {
  dialogVisible.value = false
  bookingForm.phone = ''
}

</script>

<style scoped>
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer-section {
  /* background: linear-gradient(135deg, #e0f7fa 0%, #bbdefb 100%); */
  /* padding: 80px 0; */
  text-align: center;
  height: 288px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;


  &.not-full {
    width: 70%;
    max-width: 1200px;
    margin-bottom: 50px;
    border-radius: 15px;
    margin-left: 30px;
  }
}

.footer-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;

  &.radius {
    border-radius: 15px;
  }

}

.footer-container {
  max-width: 800px;
  margin: auto;
  position: relative;
}

.title {
  font-weight: 600;
  font-size: 38px;
  color: #333333;
  margin-bottom: 12px;
}

.desc {
  font-weight: 400;
  font-size: 22px;
  color: #666666;
  margin-bottom: 26px;
}

.footer-form {
  display: flex;
  justify-content: center;
  width: 432px;
  margin: 0 auto;
  position: relative;
}

.footer-input {
  width: 432px;
  height: 53px;
}

:deep(.el-input__wrapper) {
  border-radius: 30px !important;
  border: none !important;
  height: 52px !important;
  line-height: 52px !important;
}

:deep(.el-input__inner) {
  padding: 10px;
  font-size: 18px;
}

.footer-btn {
  background-color: #8a61ff;
  background: linear-gradient(270deg, #7148FF 0%, #6B66FE 100%);
  border-color: transparent;
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 30px !important;
  height: 40px;
  padding: 0 20px;
}

.footer-btn:hover {
  /* background-color: rgba(113, 72, 255, 0.4); */
  background: linear-gradient(270deg, rgba(113, 72, 255, 0.4) 0%, rgba(107, 102, 254, 0.4) 100%);
  border-color: transparent;
}

.footer_black {
  width: 100%;
  height: 60px;
  background-color: black;
  font-weight: 400;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-btn {
  background: linear-gradient(135deg, #8a61ff 0%, #6c5ce7 100%);
  border: none;
  font-size: 16px;
  font-weight: 600;
  padding: 16px 20px;
  margin-bottom: 0px;
  border-radius: 25px;
  box-shadow: 0 8px 24px rgba(138, 97, 255, 0.3);
  transition: all 0.3s ease;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-radius: 30px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;

  .btn-text {
    height: 62px;
  }
}

.view-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(138, 97, 255, 0.4);
}

.el-icon--right {
  width: 24px;
  height: 24px;
  font-size: 24px;
  margin-left: 12px;
  animation: bounceRight 3s ease-in-out infinite;
}

@media (max-width: 768px) {
  .footer-section {
    height: 177px;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.not-full {
      width: 100%;
      max-width: 1200px;
      margin-bottom: 0px;
      border-radius: 15px;
    }

    .footer-bg-img {
      /* object-fit: fill; */
      background-image: url('@/assets/bg_footer_mobile.png');
      background-size: cover;
      background-repeat: no-repeat;

      &.radius {
        border-radius: 0px;
      }
    }

    .footer-container {
      width: 100vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .title {
        font-size: 18px;
        margin-bottom: 8px;
      }

      .desc {
        font-size: 14px;
        margin-bottom: 15px;
        width: 70%;
      }
    }

    .footer-form {
      width: 60%;

      .footer-input {
        height: 36px;
      }
    }


    .footer-btn {
      height: 30px;
      right: 3px;
      padding: 0 11px;
      font-size: 14px;
    }
  }

  .footer_black {
    padding: 0 56px;
    color: white;
    font-size: 11px;
    text-align: center;
    height: 52px;

  }

  :deep(.el-input__wrapper) {
    padding: 0 5px;
    height: 36px !important;
    line-height: 36px !important;
  }

  :deep(.el-dialog) {
    position: absolute;
    bottom: 15vh;
  }

  :deep(.el-input__inner) {
    padding: 10px;
    font-size: 14px;
  }

  /* .view-btn {

    padding: 16px 20px;
    height: 50px;
    line-height: 50px;
    border-radius: 30px;

    font-weight: 400;
    font-size: 16px;

  } */

  .view-btn {
    /* margin-top: 57px; */
    width: 120px;
    height: 35px;
    line-height: 35px;
    padding-top: 0;
    font-size: 14px;
    /* margin-bottom: 47px; */
    padding-bottom: 0;

    .btn-text {
      height: 36px;
    }
  }

  .el-icon--right {
    /* width: 24px;
    height: 24px; */
    font-size: 20px;
    margin-left: 6px;
    animation: bounceRight 3s ease-in-out infinite;
  }

}

/* 定义弹性动画关键帧 */
@keyframes bounceRight {
  0% {
    transform: translateX(0);
  }

  6.25% {
    transform: translateX(5px);
  }

  12.5% {
    transform: translateX(0);
  }

  18.75% {
    transform: translateX(5px);
  }

  25% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(0);
  }
}
</style>